import { TextField } from '../../../../primitives/index.js'
import type { FC } from 'react'
import type { FormComponentProps } from '../form-component.js'
import { capitalize } from '@tunasong/models'

export const NumberSchemaField: FC<FormComponentProps> = props => {
  const { name, spec, register, ...restProps } = props
  const label = capitalize(spec.metadata?.label ?? name)

  const setValueAs = (v?: string) => (v ? parseInt(v, 10) : undefined)
  return <TextField type="number" label={label} {...register(name, { setValueAs })} {...restProps} />
}

export default NumberSchemaField
